import { MediaLayoutLabel } from 'modules/placements/components/PlacementsCreate/components/styles';
import { MEDIA_LAYOUT_ICONS, PLACEMENT_DISPLAY_CONTENT } from 'modules/placements/constants';
import { Placement as PlacementType } from 'modules/placements/types';
import { useFormContext } from 'react-hook-form';

import { BasicFilterSelectField, BasicSelectField } from 'lib/iterable-hook-form';
import styled from 'styled-components';
import { FormField } from 'ui/formField';
import { Link } from 'ui/links';
import { spacing } from 'ui/theme';
import { useQueryPlacements } from 'modules/placements/hooks/useQueryPlacements';
import { useSelector } from 'react-redux';
import { selectDoesUserHaveRbacPermission } from 'core/userContext/selectors';
import { PROJECT_PERMISSIONS } from 'utils/permissions';

// const Caption = styled.div`
//   ${caption}
//   color: ${colors.textSecondary};
//   margin-top: ${spacing.half};
// `;

export const StyledLink = styled(Link)`
  display: flex;
  align-self: flex-end;
`;

const PlacementWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
`;

const processPlacementOptions = (opts: PlacementType[]) => {
  return opts.map(
    (opt: Pick<PlacementType, 'description' | 'id' | 'placementName' | 'mediaLayout'>) => {
      const { description, id, placementName: name, mediaLayout } = opt;
      return {
        doubleLine: description,
        id: `${id}`,
        label: name,
        Prefix: <MediaLayoutLabel>{MEDIA_LAYOUT_ICONS[mediaLayout]}</MediaLayoutLabel>,
        value: `${id}`,
      };
    },
  );
};

const DEFAULT_BASE_SELECT_FIELD_PROPS = {
  name: 'placement',
  id: 'placement-options',
  isFullWidth: true,
  title: 'placement-options',
  placeholder: 'Select placement...',
};

export const MANAGE_PLACEMENTS_ID = 'manage-placements';

export const Placement = ({
  fieldName = DEFAULT_BASE_SELECT_FIELD_PROPS.name,
}: {
  fieldName?: string;
}) => {
  const {
    formState: { errors },
  } = useFormContext();
  const canViewPlacements = useSelector(selectDoesUserHaveRbacPermission)(
    PROJECT_PERMISSIONS.ViewChannelConfiguration,
  );
  const { placements } = useQueryPlacements();

  const errorMessage = errors?.[fieldName]?.message as string | undefined;

  const options = processPlacementOptions(placements);
  const SelectField = options?.length > 5 ? BasicFilterSelectField : BasicSelectField;

  return (
    <PlacementWrapper>
      <FormField
        errorText={errorMessage}
        hasError={!!errorMessage}
        inputId="placement-field"
        labelText="Placement"
      >
        <SelectField {...DEFAULT_BASE_SELECT_FIELD_PROPS} name={fieldName} options={options} />
      </FormField>
      {/* {!errorMessage && (
        <Caption>Placements available are based on the destinations selected</Caption>
      )} */}
      {canViewPlacements && (
        <StyledLink
          variant="monochrome"
          size="caption"
          data-test={MANAGE_PLACEMENTS_ID}
          hasOpenNewTabIcon
          href={PLACEMENT_DISPLAY_CONTENT.managePlacementsPath}
          rel="noreferrer noopener"
          target="_blank"
          useReactRouter
        >
          Manage placements
        </StyledLink>
      )}
    </PlacementWrapper>
  );
};
